import { gql } from '@apollo/client';

export const postTarjetaPactarSP = gql`
mutation  TarjetaPactarSPApiRQ{
    TarjetaPactarSPApiRQ(input: $input)  
        @rest(type: "tarjetaPactarSPApiRS", path: "/api/gateway/formularios/PactarTarjeta", method: "POST"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`

